import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { GettingStartedPanelComponent } from './lib/getting-started-panel.component'
import { GettingStartedPanelKey } from './panel-key'

export * from './lib/getting-started.module'
export * from './panel-key'

export const GettingStartedPanelConfig: PanelConfig = {
  key: GettingStartedPanelKey,
  title: 'Getting Started',
  description: 'Instructions for new users of Helios.',
  category: PanelCategory.HELP,
  panelComponent: GettingStartedPanelComponent,
  accessPermission: undefined,
}
